import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import Welcome from '../containers/Welcome'
import CodeLoginForm from '../containers/CodeLoginForm'
import LoginForm from '../containers/LoginForm'
import SnapPhoto from '../containers/SnapPhoto'
import ItemShow from '../containers/ItemShow'
import ItemEdit from '../containers/ItemEdit'

import {configureStoreWithLocalStore} from '../../store'

export default function App() {
  return (
    <Provider store={configureStoreWithLocalStore()}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Welcome}>
          </Route>
          <Route path="/item/:id/edit" component={ItemEdit}>
          </Route>
          <Route path="/item/:id" component={ItemShow}>
          </Route>
          <Route path="/login" component={LoginForm}>
          </Route>
          <Route path="/use-code" component={CodeLoginForm}>
          </Route>
          <Route path="/snap-photo" component={SnapPhoto}>
          </Route>
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}



// WEBPACK FOOTER //
// ./src/snapit_app/components/App.js